import CustomDatePicker from "./DatePicker";


const InputElement = ({ label, placeholder, type = "text", disable = false, name, value, onChange, error, icon = null, isTextArea = false, isRequired = true, textRows = "3", maxLen="" }) => {

  return (
    type == "date" ? <CustomDatePicker {...{label, placeholder, name, value, onChange, error, isRequired }}/> : <div className="input-container">
      {label && <label className="input-label">{label} {(isRequired && !disable) ? <span className="text-danger" style={{fontSize: "14px"}}><sup>*</sup></span> : null}</label>}
      <div className="input-wrapper">
        {label?.includes("Mobile") ? <span className="input-icon-left">+91</span> : null}
        {isTextArea ? <textarea placeholder={placeholder} disabled={disable} onChange={onChange} value={value} type={type} name={name} className={`input-box ${error ? "input-error" : ""}`} rows={textRows} cols="50"></textarea> : <input
          name={name}
          type={type}
          disabled={disable}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          maxLength={maxLen}
          autoComplete="off"
          autoCorrect="off"
          spellCheck="false"
          className={`input-box ${error ? "input-error" : ""} ${label?.includes("Mobile") ? "mobile-no" : ""}`}
        />}
        {icon ? <span className="input-icon">{icon}</span> : null}
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
}

export default InputElement;